import { getStore } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useStoreById = (id: string | undefined) => {
  const {
    data,
    isValidating: storeLoading,
    error: storeError,
  } = useSWR(id ? id : null, getStore, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    store: data,
    storeLoading,
    storeError,
  };
};

export default useStoreById;
